/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const RICH_TEXT_CONFIG_SYNC_THROTTLE_TIMEOUT = 150;
const RICH_TEXT_FOCUSED_FIELDS_SYNC_THROTTLE_TIMEOUT = 100;

exports.RICH_TEXT_CONFIG_SYNC_THROTTLE_TIMEOUT = RICH_TEXT_CONFIG_SYNC_THROTTLE_TIMEOUT;
exports.RICH_TEXT_FOCUSED_FIELDS_SYNC_THROTTLE_TIMEOUT = RICH_TEXT_FOCUSED_FIELDS_SYNC_THROTTLE_TIMEOUT;
